<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { ddStore } from "@common/ddStore";

let vmsCustomAttributeGroupChangeConfig = {
    cId: "vmsCustomAttributeGroupChange",
    cType: "vmsCustomAttributeGroupChange",
    cTitle: "Change Attribute Group",
    cTemplate: `<div :id="wrapperID" class="vmsCustomAttributeGroupChange-wrapper" :class="{'is-from-popup': isFromPopup}">
                    <div class="vmsCustomAttributeGroupChange-title">Change Attribute Group</div>
                    <div class="vmsCustomAttributeGroupChange-subTitle">
                        <span>Which group do you want to move the selected attribute to?</span>
                    </div>
                    <div class="vmsCustomAttributeGroupChange-Wrapper">
                        <div class="vmsCustomAttributeGroupChange-mainWrapper">
                            <div class="vmsCustomAttributeGroupChange-groupList-header">
                                <span>{{listTitle ?? 'Groups'}}</span>
                            </div>
                            <div>
                                <control name="CUSTOM_ATTRIBUTE_GROUP_CHANGE_GROUP_SEARCH" @update:value="groupFilter"></control>
                            </div>
                            <div>
                                <div v-if="groupList.length && isGroupFiltering() && !filterGroupList.length" class="vmsCustomAttributeGroupChange-groupList-control __empty">
                                    <span>No results found for your search</span>
                                </div>
                                <control v-else name="GROUP_LIST" :items="isGroupFiltering() ? filterGroupList : groupList" class="vmsCustomAttributeGroupChange-groupList-control"></control>
                            </div>
                            <div class="vmsCustomAttributeGroupChange-applyVolunteer">
                                <control name="CUSTOM_ATTRIBUTE_GROUP_CHANGE_APPLY_VOLUNTEER"></control>
                            </div>
                        </div>
                    </div>
                    <div class="vmsCustomAttributeGroupChange-buttons">
                        <div class="vmsCustomAttributeGroupChange-button"><control name="CUSTOM_ATTRIBUTE_MANAGER_OK_BUTTON"></control></div>
                        <div class="vmsCustomAttributeGroupChange-button"><control name="CUSTOM_ATTRIBUTE_MANAGER_CANCEL_BUTTON"></control></div>
                    </div>
               </div>
               `,
    controls: [
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CHANGE_GROUP_SEARCH',
            type: 'string',
            hideMessage: true,
            showClearButton: true,
            fields: { text: 'text', value: 'value' },
            isNotDDPlaceholder: true,
            placeholder: 'Enter name for search',
            ref: 'vmsCustomAttributeGroupChangeGroupSearch'
        },
        {
            name: 'CUSTOM_ATTRIBUTE_GROUP_CHANGE_APPLY_VOLUNTEER',
            type: 'checkbox',
            label: 'DD.CUSTOM_ATTRIBUTE.CUSTOMATTRIBUTEMANAGER_GROUP_CHANGE_APPLY_VOLUNTEER',
            ref: 'vmsCustomAttributeGroupChangeChangeApplyVolunteer'
        },
        {
            name: 'GROUP_LIST',
            type: 'list',
            onclick: 'selectGroup',
            itemContentTemplate: `
                <div class="vmsCustomAttributeGroupChange-itemList">
                    <div class="vmsCustomAttributeGroupChange-itemList-cell">
                        <div class="vmsCustomAttributeGroupChange-itemList-cell-whiteSpace">
                            <div v-if="component.currentGroupId === data.groupID" class="vmsCustomAttributeGroupChange-itemList-cell-isActive"></div>
                        </div>
                        {{data.groupName}}
                        <span v-if="component.clientIsAdminOrStaff" class="vmsCustomAttributeGroupChange-itemId">&nbsp;(#{{data.groupID}})</span>
                    </div>
                </div>
                `
        },
        // bottom buttons
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_OK_BUTTON',
            type: 'button',
            label: 'OK',
            onclick: 'save',
        },
        {
            name: 'CUSTOM_ATTRIBUTE_MANAGER_CANCEL_BUTTON',
            type: 'button',
            label: 'Cancel',
            onclick: 'close',
        },
    ]
};

let vmsCustomAttributeGroupChangeCmp = {
    name: 'vmsCustomAttributeGroupChange',
    preInitControls: true,
    props: {
        isFromPopup: {
            default: false
        },
        perspectiveId: {
            type: Number,
            default: null
        },
        groupList: {
            type: Array,
            default: []
        },
        attrGroupId: {
            type: Number,
            default: null
        },
        attrIds: {
            type: Array,
            default: []
        },
        listTitle: {
            type: String,
            default: null
        },
        changeCallback: {
            type: Function,
            default: null
        },
    },
    data() {
        return {
            currentGroupId: null,
            filterGroupList: []
        };
    },
    computed: {
        clientIsAdminOrStaff() {
            if (
                typeof this.userStore.coordinator === 'undefined'
                || (
                    typeof this.userStore.coordinator.CLIENT_IS_ADMIN === 'undefined'
                    && typeof this.userStore.coordinator.CLIENT_IS_STAFF === 'undefined'
                )
            ) {
                return false;
            }
            return this.userStore.coordinator.CLIENT_IS_ADMIN === 'Yes' || this.userStore.coordinator.CLIENT_IS_STAFF === 'Yes';
        },
        wrapperID() {
            return this.cId + 'Wrapper';
        },
    },
    components: {
        labelWrapper: defineAsyncComponent(() => import('@common/control/labelWrapper'))
    },
    methods: {
        isGroupFiltering() {
            if (typeof this.controls['CUSTOM_ATTRIBUTE_GROUP_CHANGE_GROUP_SEARCH'] === 'undefined') {
                return false;
            }
            return this.controls['CUSTOM_ATTRIBUTE_GROUP_CHANGE_GROUP_SEARCH'].value.length > 2;
        },
        groupFilter() {
            if (!this.isGroupFiltering()) {
                this.filterGroupList = [];
                return;
            }
            let searchText = this.controls['CUSTOM_ATTRIBUTE_GROUP_CHANGE_GROUP_SEARCH'].value.toLowerCase().trim();
            this.filterGroupList = this.groupList.filter((item) => item.groupName.toLowerCase().includes(searchText));
            if (this.currentGroupId && this.filterGroupList.indexOf(this.currentGroupId) === -1) {
                this.currentGroupId = null;
            }
        },
        async onLoad() {
            this.$emit('update:vmsCustomAttributeGroupChangeLoaded', true);
            if (typeof this.attrGroupId !== 'number' || !this.attrGroupId) {
                this.attrGroupId = null;
            }
            if (typeof this.groupList !== 'object') {
                this.groupList = [];
            }
            if (typeof this.attrIds !== 'object') {
                this.attrIds = [];
            }
            if (typeof this.listTitle !== 'string' || !this.listTitle) {
                this.listTitle = null;
            }
        },
        async selectGroup(groupInfo) {
            this.currentGroupId = groupInfo.groupID;
        },
        async save() {
            if (this.currentGroupId) {
                library.showLoadingIndicator(this.wrapperID);
                let newGroupId = this.currentGroupId;
                let attrIds = this.attrIds;
                let isApplyChangeVol = this.controls['CUSTOM_ATTRIBUTE_GROUP_CHANGE_APPLY_VOLUNTEER'].value;
                let response = await this.changeGroupCustomAttributes(newGroupId, attrIds, isApplyChangeVol);
                library.hideLoadingIndicator(this.wrapperID);
                if (response && response.status === 'success' && typeof response.data !== 'undefined') {
                    if (typeof this.changeCallback === 'function') {
                        this.changeCallback();
                    }
                    this.close();
                } else if (response && typeof response.error === 'object' && response.error.length) {
                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                    library.showDialog(response.error[0], false, false, {
                        title: title, name: 'vmsCustomAttributeGroupChangeError', preventCloseOnBackdropClick: true, showAsAlert: true
                    });
                } else {
                    this.close();
                }
            } else {
                if (typeof this.changeCallback === 'function') {
                    this.changeCallback();
                }
                this.close();
            }
        },
        close() {
            if (/openvmsCustomAttributeGroupChange/g.test(window.name)) {
                window.close();
            } else if (
                this.$parent
                && this.$parent.$parent
                && this.$parent.$parent.$parent
                && typeof this.$parent.$parent.$parent.componentDialogs === 'object'
                && this.$parent.$parent.$parent.componentDialogs.length
            ) {
                this.$parent.$parent.$parent.componentDialogs.find((component) => component.name === 'openvmsCustomAttributeGroupChange')?.cancelButton?.click();
            }
        },
        // sDs
        async changeGroupCustomAttributes(newGroupID, attrIDs, isApplyChangeVol) {
            return this.sDs.post('ec_changeGroupCustomAttributes', newGroupID, attrIDs, isApplyChangeVol);
        },
    }
};

componentStore.initComponent(vmsCustomAttributeGroupChangeCmp, vmsCustomAttributeGroupChangeConfig);
export { vmsCustomAttributeGroupChangeConfig, vmsCustomAttributeGroupChangeCmp };
export default vmsCustomAttributeGroupChangeCmp;
</script>

<style>
#dialog_container_openvmsCustomAttributeGroupChange, #dialog_container_openvmsCustomAttributeGroupChange > div {
    height: 400px;
}
.vmsCustomAttributeGroupChange-itemId {
    color: #d3d3d3;
}
</style>
<style scoped>
:deep(.vmsCustomAttributeGroupChange-title) {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: #41362f;
}
:deep(.vmsCustomAttributeGroupChange-subTitle) {
    margin-top: 20px;
    text-align: center;
}
:deep(.vmsCustomAttributeGroupChange-Wrapper) {
    display: flex;
}
:deep(.vmsCustomAttributeGroupChange-mainWrapper) {
    margin-top: 20px;
    width: 100%;
    display: inline-block;
}
:deep(.vmsCustomAttributeGroupChange-groupList-header) {
    background: #cfd8dc;
    padding: 5px;
    min-height: 30px;
    align-items: center;
    display: flex;
}
:deep(.vmsCustomAttributeGroupChange-groupList-header span) {
    font-weight: bold;
    font-size: 13px;
    margin-left: 25px;
}
:deep(.vmsCustomAttributeGroupChange-groupList-control) {
    height: 200px;
    overflow-y: auto;
}
:deep(.vmsCustomAttributeGroupChange-groupList-control.__empty) {
    text-align: center;
    padding: 20px;
}
:deep(.vmsCustomAttributeGroupChange-itemList) {
    width: 100%;
    min-height: 30px;
    padding: 5px;
    display: flex;
    font-weight: bolder;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 1px solid #dadce0;
}
:deep(.vmsCustomAttributeGroupChange-itemList:hover) {
    background:#e8f0fe;
}
:deep(.vmsCustomAttributeGroupChange-itemList-cell) {
    margin: 0 5px;
    display: inline-flex;
    align-items: center;
}
:deep(.vmsCustomAttributeGroupChange-itemList-cell-whiteSpace) {
    width: 12px;
    margin-right: 10px;
}
:deep(.vmsCustomAttributeGroupChange-itemList-cell-isActive) {
    width: 12px;
    height: 12px;
    background: #1976d2;
    border-radius: 50%;
}
:deep(.vmsCustomAttributeGroupChange-applyVolunteer) {
    margin: 20px 10px 0 10px;
}
:deep(.vmsCustomAttributeGroupChange-wrapper) {
    width: 100%;
    height: 400px;
    background-color: #fff;
    padding: 20px;
}
:deep(.is-from-popup) {
    width: 100%;
    height: 100%;
}
:deep(.vmsCustomAttributeGroupChange-buttons) {
    text-align: center;
    margin-top: 20px;
    clear: both;
}
:deep(.vmsCustomAttributeGroupChange-button) {
    display: inline-block;
    margin-left: 20px;
    width: 90px;
}
</style>
